import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { api, ChildOrganizationListDto } from '@sib/api';
import { QueryKey } from '@sib/api/enums';

type ChildOrgQueryPayload = Parameters<
  typeof api.organization.childOrganizationControllerGetChildrenOrganizations
>[1];

export const useGetChildOrganizations = (
  organizationId: string,
  payload: ChildOrgQueryPayload,
  options?: UseQueryOptions<ChildOrganizationListDto>
) =>
  useQuery({
    enabled: !!organizationId,
    queryKey: [QueryKey.Resource.ChildOrganizations, organizationId, payload],
    queryFn: () =>
      api.organization.childOrganizationControllerGetChildrenOrganizations(
        organizationId,
        payload
      ),
    ...options,
  });
